import { render, staticRenderFns } from "./appPageBuilder.vue?vue&type=template&id=20d02742"
import script from "./appPageBuilder.vue?vue&type=script&lang=js"
export * from "./appPageBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports